import styled from 'styled-components'
import { colors } from 'styles/colors'
import { mobile } from 'styles/responsive'

import BaseButton from 'components/Button'

export const Container = styled.div`
    max-width: 1110px;
    position: relative;

    display: flex;
    flex-direction: column;

    align-items: center;
    justify-content: center;
    text-align: center;

    overflow: hidden;

    > * + * {
        margin-top: 50px;
    }
`

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    width: 100%;

    > * + * {
        margin-top: 15px;
    }

    ${mobile(`
        padding: 15px 15px 0 15px;
    `)}
`

export const Title = styled.h1`
    font-size: 50px;
    font-style: italic;
    font-weight: 800;
    line-height: 50px;
    text-align: center;
    color: ${colors.purplePod};

    ${mobile(`
       font-size: 32px;
    `)}
`

export const Desc = styled.div`
    font-size: 16px;
    font-weight: 700;
    line-height: 22.4px;
    text-align: center;

    color: ${colors.black};
`

export const Link = styled.a`
    text-decoration: none;

    color: ${colors.defaultGreen};
`

export const LinkNoMobile = styled.a`
    text-decoration: none;
    color: ${colors.defaultGreen};

    ${mobile(`
        display: none;
    `)}
`

export const Button = styled(BaseButton)`
    margin: 10px 0 0;
    padding: 16px 30px;
    font-size: 16px;
    font-weight: 800;
    background-color: ${({ $background }) => $background ?? colors.deepPurple};

    color: ${({ $color }) => $color ?? colors.white};

    &:hover {
        box-shadow: 0 0 12px 3px
            ${({ $background }) => $background ?? colors.deepPurple};
    }

    &:active {
        background-color: ${({ $background }) =>
            $background ?? colors.deepPurple};
    }
`
